const API_URL = import.meta.env.VITE_API_URL || '';

const UPLOAD_URL = import.meta.env.VITE_UPLOAD_URL || '';

const PICSART_APP_URL = import.meta.env.VITE_PICSART_APP_URL || '';

const LIBRARY_TABS_KEY = import.meta.env.VITE_LIBRARY_TABS_KEY || '';

const LIBRARY_BASE_URL = import.meta.env.VITE_LIBRARY_URL || '';

const LIBRARY_SECTIONS_URL = `${LIBRARY_BASE_URL}/hubs/${LIBRARY_TABS_KEY}/grids/flow?landingType=flow&expand=uploadItems,textItems,hasEditOption`;

const LIBRARY_TRENDING_URL = `${LIBRARY_BASE_URL}/hubs/${LIBRARY_TABS_KEY}/trending`;

const FLOW_LANDINGS_URL = `${LIBRARY_BASE_URL}/flow-landings/slug`;

const SHOP_ITEMS_SEARCH_URL = `${API_URL}/shop/items/search`;
/** Server caps `pagination[pageSize]` at 100; larger values are silently clamped. */
const NEW_PRESETS_PAGE_SIZE = 25;

/** `width`/`height` sit top-level on images but only inside `provider_metadata` on videos . */
const NEW_PRESETS_MEDIA_FIELDS = 'url,width,height,provider_metadata';

const NEW_PRESETS_QUERY = new URLSearchParams({
  sort: 'createdAt:desc',
  'pagination[pageSize]': String(NEW_PRESETS_PAGE_SIZE),
  'filters[hideFromPicsart][$eq]': 'false',
  fields: 'slug,title,type,description,flow',
  'populate[video][populate][media][fields]': NEW_PRESETS_MEDIA_FIELDS,
  'populate[image][populate][media][fields]': NEW_PRESETS_MEDIA_FIELDS,
}).toString();

const NEW_PRESETS_URL = `${LIBRARY_BASE_URL}/flow-landings?${NEW_PRESETS_QUERY}`;

/**
 * Adjust short-link generators. One per app a share link can open — the two
 * apps have different schemes and separate Adjust configurations, so a link
 * built for one never resolves in the other.
 */
const PICSART_DEEPLINK_URL = `${API_URL}/v1/picsart/deeplink`;

const GENAI_DEEPLINK_URL = `${API_URL}/v1/genai/deeplink`;

const MAGIC_FLOW_WEBHOOK_URL = `${API_URL}/workflows/magic-flow-webhook`;

const SUBMIT_WEB_HOOK_URL = `${MAGIC_FLOW_WEBHOOK_URL}/submit`;

const MAGIC_FLOW_OPTIONS_URL = `${MAGIC_FLOW_WEBHOOK_URL}/options`;

const FREE_QUOTA_SUBMIT_WEB_HOOK_URL = `${API_URL}/guest/workflows/magic-flow-webhook/submit`;

const FREE_PASS_API_URL = import.meta.env.VITE_FREE_PASS_API_URL || '';

const FREE_PASS_PROMO_ID = import.meta.env.VITE_FREE_PASS_PROMO_ID || '';

const MOBILE_EDITOR_URL = 'picsart://apps';

/** Standalone GenAI portfolio app — its own scheme, not the Picsart app's. */
const PORTFOLIO_APP_URL = 'gen.ai://open';

/** Scheme the Picsart app resolves as "open this miniapp inside the editor". */
const PICSART_MINIAPP_SCHEME_URL = 'picsart://miniapp_2_editor';

/**
 * Scheme the standalone GenAI app's *share* links are registered under in
 * Adjust. Deliberately not `PORTFOLIO_APP_URL` — push notifications deeplink
 * with `gen.ai://open`, share links with `genai://open`, and the two are
 * configured separately upstream.
 */
const PORTFOLIO_SHARE_SCHEME_URL = 'genai://open';

/**
 * Web fallback for GenAI-app share links. Intentionally not per-environment,
 * unlike `PICSART_APP_URL`: the standalone app has no stage web surface, so
 * every build points at the production site. The Adjust *endpoint* it's posted
 * to is still env-derived (`GENAI_DEEPLINK_URL` off `API_URL`).
 */
const PORTFOLIO_SHARE_WEB_URL = 'https://gen.ai/';

const SIGNOUT_URL = `${API_URL}/users/signout.json`;

const DRIVE_FILES_URL = `${API_URL}/drive/v1/files`;

const PRESET_LIKES_URL = `${API_URL}/flow-template-publisher/likes`;

export {
  API_URL,
  UPLOAD_URL,
  PICSART_APP_URL,
  LIBRARY_TABS_KEY,
  LIBRARY_BASE_URL,
  LIBRARY_SECTIONS_URL,
  LIBRARY_TRENDING_URL,
  FLOW_LANDINGS_URL,
  SHOP_ITEMS_SEARCH_URL,
  NEW_PRESETS_URL,
  PICSART_DEEPLINK_URL,
  GENAI_DEEPLINK_URL,
  MAGIC_FLOW_WEBHOOK_URL,
  SUBMIT_WEB_HOOK_URL,
  MAGIC_FLOW_OPTIONS_URL,
  FREE_QUOTA_SUBMIT_WEB_HOOK_URL,
  FREE_PASS_API_URL,
  FREE_PASS_PROMO_ID,
  MOBILE_EDITOR_URL,
  PORTFOLIO_APP_URL,
  PICSART_MINIAPP_SCHEME_URL,
  PORTFOLIO_SHARE_SCHEME_URL,
  PORTFOLIO_SHARE_WEB_URL,
  SIGNOUT_URL,
  DRIVE_FILES_URL,
  PRESET_LIKES_URL,
};
